module.exports = __webpack_public_path__ + "static/ubuntu-regular-694f32f4f139e578f8303309a343cfa0.ttf";